"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var _Card = _interopRequireDefault(require("../../../components/Card"));
var _utils = require("@/utils");
var _formMixin = _interopRequireDefault(require("../../formMixin"));
var _draggableEffect = _interopRequireDefault(require("../../../components/js/draggableEffect"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CarouselForm',
  mixins: [_formMixin.default, _draggableEffect.default],
  components: {
    linkaddressVue: _linkaddress.default,
    Card: _Card.default
  },
  data: function data() {
    return {
      initData: {
        url: '',
        pic: '',
        name: ''
      },
      form: {
        showType: 1,
        banner: [{
          url: ''
        }],
        bannerHeight: 160,
        bannerPadding: {
          pt: 10,
          pb: 10,
          pl: 15,
          pr: 15
        }
      },
      itemIndex: null
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.bannerPadding)) {
          this.$set(this.form, 'bannerPadding', {
            pt: 10,
            pb: 10,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    linkUrl: function linkUrl(url) {
      this.form.banner[this.itemIndex].url = url;
    },
    openLink: function openLink(index) {
      this.itemIndex = index;
      this.$refs.linkaddressVueRef.dialogVisible = true;
    },
    upload: function upload(index) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form.banner[index], 'pic', data[0].sattDir);
      });
    },
    handleRemove: function handleRemove(index) {
      this.form.banner.splice(index, 1);
    },
    addContent: function addContent() {
      this.form.banner.push((0, _utils.deepCopy)(this.initData));
    },
    handleDragenter: function handleDragenter(index) {
      this.dragging = index;
      var banner = _toConsumableArray(this.form.banner);
      var currentIndex = index;
      var dragStartIndex = this.dragStartIndex;
      if (currentIndex !== dragStartIndex) {
        var temp = banner[currentIndex];
        banner[currentIndex] = banner[dragStartIndex];
        banner[dragStartIndex] = temp;
        this.dragStartIndex = currentIndex;
      }
      this.form.banner = banner;
    }
  }
};